module.exports = __webpack_public_path__ + "img/star6.53cf7408.png";